import ApiClient from 'api-client/ApiClient'
import { VirtualMachineLite } from '../newModel'

export const VALID_SERVER_GROUP_VM_STATES = ['active', 'stopped']

const DESIRED_VM_FIELDS = [
  'name',
  'id',
  'state',
  'hostname',
  'ownerName',
  'OS-EXT-SRV-ATTR:host',
  'OS-EXT-SRV-ATTR:hypervisor_hostname',
]

const { nova } = ApiClient.getInstance()

export async function fetchEligibleServerGroupVMs(
  stateNames: string[] = VALID_SERVER_GROUP_VM_STATES,
  desiredFields: string[] = DESIRED_VM_FIELDS,
): Promise<VirtualMachineLite[]> {
  const stateQueries = stateNames.map((state) =>
    nova.getAllInstancesLite(`vm_state=${state.toUpperCase()}`, null, desiredFields),
  )

  const response = await Promise.allSettled(stateQueries)

  const vms: VirtualMachineLite[] = []
  response.forEach((r) => {
    if (r.status === 'fulfilled') {
      vms.push(...(r.value || []))
    }
  })

  return vms
}
